import * as i0 from '@angular/core';
import { ElementRef, Component, ChangeDetectionStrategy, Inject, Input, HostBinding, NgModule } from '@angular/core';
import * as i4 from '@taiga-ui/cdk';
import { tuiTypedFromEvent, ALWAYS_TRUE_HANDLER, ALWAYS_FALSE_HANDLER, tuiIsNativeFocused, TuiFocusVisibleService, tuiAsFocusableItemAccessor, TuiDestroyService } from '@taiga-ui/cdk';
import { MODE_PROVIDER } from '@taiga-ui/core/providers';
import { TUI_MODE } from '@taiga-ui/core/tokens';
import * as i3 from 'rxjs';
import { merge } from 'rxjs';
import { map } from 'rxjs/operators';
import * as i1 from '@taiga-ui/core/components/svg';
import { TuiSvgModule } from '@taiga-ui/core/components/svg';
import * as i2 from '@angular/common';
import { CommonModule } from '@angular/common';

// @bad TODO: Think about extending Interactive
class TuiLinkComponent {
    constructor(el, mode$, focusVisible$) {
        this.el = el;
        this.mode$ = mode$;
        this.pseudo = false;
        this.icon = '';
        this.iconAlign = 'right';
        this.iconRotated = false;
        this.mode = null;
        this.focusVisible = false;
        this.focusedChange = merge(tuiTypedFromEvent(this.el.nativeElement, 'focusin').pipe(map(ALWAYS_TRUE_HANDLER)), tuiTypedFromEvent(this.el.nativeElement, 'focusout').pipe(map(ALWAYS_FALSE_HANDLER)));
        focusVisible$.subscribe(visible => {
            this.focusVisible = visible;
        });
    }
    get nativeFocusableElement() {
        return this.el.nativeElement;
    }
    get focused() {
        return tuiIsNativeFocused(this.nativeFocusableElement);
    }
    get hasIcon() {
        return !!this.icon;
    }
    get iconAlignLeft() {
        return this.hasIcon && this.iconAlign === 'left';
    }
    get iconAlignRight() {
        return this.hasIcon && this.iconAlign === 'right';
    }
}
TuiLinkComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: TuiLinkComponent, deps: [{ token: ElementRef }, { token: TUI_MODE }, { token: TuiFocusVisibleService }], target: i0.ɵɵFactoryTarget.Component });
TuiLinkComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.2.17", type: TuiLinkComponent, selector: "a[tuiLink], button[tuiLink]", inputs: { pseudo: "pseudo", icon: "icon", iconAlign: "iconAlign", iconRotated: "iconRotated", mode: "mode" }, host: { listeners: { "$.data-mode.attr": "mode$" }, properties: { "class._pseudo": "this.pseudo", "class._icon-rotated": "this.iconRotated", "attr.data-host-mode": "this.mode", "class._focus-visible": "this.focusVisible" } }, providers: [
        tuiAsFocusableItemAccessor(TuiLinkComponent),
        TuiFocusVisibleService,
        TuiDestroyService,
        MODE_PROVIDER,
    ], exportAs: ["tuiLink"], ngImport: i0, template: "<tui-svg\n    *ngIf=\"iconAlignLeft\"\n    class=\"t-icon t-icon_left\"\n    [src]=\"icon || ''\"\n></tui-svg>\n<span class=\"t-content\">\n    <ng-content></ng-content>\n</span>\n<tui-svg\n    *ngIf=\"iconAlignRight\"\n    class=\"t-icon t-icon_right\"\n    [src]=\"icon || ''\"\n></tui-svg>\n", styles: [":host{-webkit-appearance:none;-moz-appearance:none;appearance:none;padding:0;border:0;background:none;font-size:inherit;line-height:inherit;transition-property:color;transition-duration:var(--tui-duration, .3s);transition-timing-function:ease-in-out;color:var(--tui-link);text-decoration:none;text-align:left;text-transform:inherit;font-weight:inherit;cursor:pointer;outline:none}:host:hover{color:var(--tui-link-hover)}:host:disabled{opacity:var(--tui-disabled-opacity);cursor:default}:host[data-mode=onLight]{color:var(--tui-text-02)}:host[data-mode=onLight]:hover,:host[data-mode=onLight]._active{color:var(--tui-text-01)}:host[data-mode=onLight]._pseudo{color:var(--tui-text-01)}:host[data-mode=onLight]._pseudo .t-content{-webkit-text-decoration-color:rgba(0,0,0,.48);text-decoration-color:#0000007a}:host[data-mode=onLight]._pseudo:hover,:host[data-mode=onLight]._pseudo._active{color:var(--tui-text-03)}:host[data-mode=onLight][data-host-mode=negative]{color:var(--tui-negative-night)}:host[data-mode=onLight][data-host-mode=negative]:hover,:host[data-mode=onLight][data-host-mode=negative]:active,:host[data-mode=onLight][data-host-mode=negative]._active{color:var(--tui-negative-night-hover)}:host[data-mode=onDark]{color:var(--tui-text-03-night)}:host[data-mode=onDark]:hover,:host[data-mode=onDark]:active,:host[data-mode=onDark]._active{color:var(--tui-text-01-night)}:host[data-mode=onDark]._pseudo{color:var(--tui-text-01-night)}:host[data-mode=onDark]._pseudo .t-content{-webkit-text-decoration-color:rgba(255,255,255,.48);text-decoration-color:#ffffff7a}:host[data-mode=onDark]._pseudo:hover,:host[data-mode=onDark]._pseudo:active,:host[data-mode=onDark]._pseudo._active{color:var(--tui-text-03-night)}:host[data-mode=onDark][data-host-mode=positive]{color:var(--tui-positive-night)}:host[data-mode=onDark][data-host-mode=positive]:hover,:host[data-mode=onDark][data-host-mode=positive]:active,:host[data-mode=onDark][data-host-mode=positive]._active{color:var(--tui-positive-night-hover)}:host[data-host-mode=negative]{color:var(--tui-negative)}:host[data-host-mode=negative]:hover{color:var(--tui-negative-hover)}:host[data-host-mode=negative]._pseudo .t-content{-webkit-text-decoration-color:rgba(222,76,30,.48);text-decoration-color:#de4c1e7a}:host[data-host-mode=positive]{color:var(--tui-positive)}:host[data-host-mode=positive]:hover{color:var(--tui-positive-hover)}:host[data-host-mode=positive]._pseudo .t-content{-webkit-text-decoration-color:rgba(58,169,129,.48);text-decoration-color:#3aa9817a}:host._focus-visible .t-content{background:var(--tui-selection)}:host[data-mode=onLight]._focus-visible .t-content{background:var(--tui-clear);color:var(--tui-text-01)}:host[data-mode=onDark]._focus-visible .t-content{background:var(--tui-clear-inverse);color:var(--tui-text-01-night)}:host[data-host-mode=positive]._focus-visible .t-content{background:var(--tui-success-bg)}:host[data-host-mode=negative]._focus-visible .t-content{background:var(--tui-error-bg)}:host._pseudo .t-content{padding-bottom:.15em;-webkit-text-decoration:underline dashed rgba(51,111,238,.48);text-decoration:underline dashed rgba(51,111,238,.48);text-underline-offset:.2em;text-decoration-thickness:.7px}.t-icon{transition-property:transform;transition-duration:var(--tui-duration, .3s);transition-timing-function:ease-in-out;width:var(--tui-link-icon-size, 1.5rem);height:var(--tui-link-icon-size, 1.5rem);margin-top:-.125rem}.t-icon_left{margin-right:.25rem}.t-icon_right{margin-left:.25rem}:host._icon-rotated .t-icon{transform:rotate(180deg)}\n"], components: [{ type: i1.TuiSvgComponent, selector: "tui-svg", inputs: ["src"] }], directives: [{ type: i2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: TuiLinkComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'a[tuiLink], button[tuiLink]',
                    templateUrl: './link.template.html',
                    styleUrls: ['./link.style.less'],
                    providers: [
                        tuiAsFocusableItemAccessor(TuiLinkComponent),
                        TuiFocusVisibleService,
                        TuiDestroyService,
                        MODE_PROVIDER,
                    ],
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    exportAs: 'tuiLink',
                    host: {
                        '($.data-mode.attr)': 'mode$',
                    },
                }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef, decorators: [{
                    type: Inject,
                    args: [ElementRef]
                }] }, { type: i3.Observable, decorators: [{
                    type: Inject,
                    args: [TUI_MODE]
                }] }, { type: i4.TuiFocusVisibleService, decorators: [{
                    type: Inject,
                    args: [TuiFocusVisibleService]
                }] }]; }, propDecorators: { pseudo: [{
                type: Input
            }, {
                type: HostBinding,
                args: ['class._pseudo']
            }], icon: [{
                type: Input
            }], iconAlign: [{
                type: Input
            }], iconRotated: [{
                type: Input
            }, {
                type: HostBinding,
                args: ['class._icon-rotated']
            }], mode: [{
                type: Input
            }, {
                type: HostBinding,
                args: ['attr.data-host-mode']
            }], focusVisible: [{
                type: HostBinding,
                args: ['class._focus-visible']
            }] } });

class TuiLinkModule {
}
TuiLinkModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: TuiLinkModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
TuiLinkModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: TuiLinkModule, declarations: [TuiLinkComponent], imports: [CommonModule, TuiSvgModule], exports: [TuiLinkComponent] });
TuiLinkModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: TuiLinkModule, imports: [[CommonModule, TuiSvgModule]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: TuiLinkModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule, TuiSvgModule],
                    declarations: [TuiLinkComponent],
                    exports: [TuiLinkComponent],
                }]
        }] });

/**
 * Generated bundle index. Do not edit.
 */

export { TuiLinkComponent, TuiLinkModule };
